const SNOOZE_UNTIL_KEY = "seevi_notification_prompt_snooze_until";
const SESSION_DISMISSED_KEY = "seevi_notification_prompt_dismissed_session";
const SESSION_PROMPT_SHOWN_KEY = "seevi_notification_prompt_shown_session";
const PENDING_AFTER_LOGIN_KEY = "seevi_notification_prompt_pending_login";

/** 7 days — "Not now" */
const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

export function markNotificationPromptPendingAfterLogin(): void {
  try {
    sessionStorage.setItem(PENDING_AFTER_LOGIN_KEY, "1");
    sessionStorage.removeItem(SESSION_PROMPT_SHOWN_KEY);
  } catch {
    /* ignore storage errors */
  }
}

export function consumeNotificationPromptPendingAfterLogin(): boolean {
  try {
    const pending = sessionStorage.getItem(PENDING_AFTER_LOGIN_KEY) === "1";
    if (pending) {
      sessionStorage.removeItem(PENDING_AFTER_LOGIN_KEY);
    }
    return pending;
  } catch {
    return false;
  }
}

export function markNotificationPromptShownForSession(): void {
  try {
    sessionStorage.setItem(SESSION_PROMPT_SHOWN_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function isNotificationPromptShownForSession(): boolean {
  try {
    return sessionStorage.getItem(SESSION_PROMPT_SHOWN_KEY) === "1";
  } catch {
    return false;
  }
}

export function isNotificationPromptSnoozed(): boolean {
  if (typeof window === "undefined") return true;
  if (sessionStorage.getItem(SESSION_DISMISSED_KEY) === "1") return true;
  if (sessionStorage.getItem(SESSION_PROMPT_SHOWN_KEY) === "1") return true;

  const until = localStorage.getItem(SNOOZE_UNTIL_KEY);
  if (!until) return false;
  const ts = Number(until);
  return Number.isFinite(ts) && Date.now() < ts;
}

export function snoozeNotificationPromptForSession(): void {
  sessionStorage.setItem(SESSION_DISMISSED_KEY, "1");
}

export function snoozeNotificationPromptExtended(): void {
  localStorage.setItem(SNOOZE_UNTIL_KEY, String(Date.now() + SNOOZE_MS));
  sessionStorage.setItem(SESSION_DISMISSED_KEY, "1");
}

export function clearNotificationPromptSnooze(): void {
  localStorage.removeItem(SNOOZE_UNTIL_KEY);
  sessionStorage.removeItem(SESSION_DISMISSED_KEY);
  sessionStorage.removeItem(SESSION_PROMPT_SHOWN_KEY);
  sessionStorage.removeItem(PENDING_AFTER_LOGIN_KEY);
}
